import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { initMonitoring } from "./lib/monitoring";
import { initPerformanceMonitoring } from "./lib/performance";

// Initialize monitoring in production
if (import.meta.env.PROD) {
  initMonitoring();
  initPerformanceMonitoring();
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
